import { RequireAutorization } from './routerAuth'

export const ROUTE_SCHEDULE = {
  name: 'Schedule',
  path: '/agenda',
  component: () => import(/* webpackChunkName: "schedule" */'@/components/Schedule/Schedule'),
  meta: {title: 'Agenda'},
  beforeEnter: RequireAutorization
}
